import React from "react";
import { withRouter } from "react-router-dom";
import { withStyles } from "@material-ui/core/styles";
import Fab from "@material-ui/core/Fab";
import AddIcon from "@material-ui/icons/Add";
import Card from "@material-ui/core/Card";
import classnames from "classnames";
import CardContent from "@material-ui/core/CardContent";
import Collapse from "@material-ui/core/Collapse";
import Divider from "@material-ui/core/Divider";
import { primaryShade1, primaryShade2, grey, red } from "../styles/color";
import moment from "moment";

const styles = theme => ({
  media: {
    height: 0,
    paddingTop: "56.25%" // 16:9
  },
  actions: {
    display: "flex"
  },
  expand: {
    transform: "rotate(0deg)",
    marginLeft: "auto",
    transition: theme.transitions.create("transform", {
      duration: theme.transitions.duration.shortest
    })
  },
  expandOpen: {
    transform: "rotate(0deg)"
  },
  avatar: {
    backgroundColor: red
  }
});
class ClosedDeals extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      expanded: false,
      months: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
      ]
    };
  }
  handleExpandClick = index => {
    this.setState(state => ({
      expanded: index === this.state.expanded ? false : index
    }));
  };
  getDateValue = dateValue => {
    let recievedDateType = typeof dateValue;
    let currentDate =
      recievedDateType === "object"
        ? dateValue.toDate()
        : moment(dateValue).toDate();
    let date = currentDate.getDate();
    let month = this.state.months[currentDate.getMonth()];
    let year = currentDate
      .getYear()
      .toString()
      .substr(-2);
    let dateMonthYear = date + " " + month + " " + year;
    return dateMonthYear;
  };
  render() {
    const { classes, closedDeals, transactions, allDeals } = this.props;
    return closedDeals.length === 0 ? (
      <div
        style={{
          height: "calc(100vh - 160px)",
          overflow: "scroll"
        }}
      >
        <div
          style={{
            display: "flex",
            height: "40px",
            justifyContent: "space-around",
            alignItems: "center"
          }}
        >
          <h3
            style={{
              position: "fixed",
              bottom: "100px",
              top: "48%",
              justifyContent: "center",
              alignItems: "center"
            }}
          >
            {allDeals.length > 0
              ? "No Deals Are Closed Yet"
              : "No Deals Are Created Yet"}
          </h3>
        </div>
        <Fab
          aria-label="Add"
          style={{
            position: "fixed",
            bottom: "70px",
            right: "20px",
            backgroundColor: primaryShade1
          }}
          onClick={e => {
            e.preventDefault();
            this.props.history.push("/deals/addDeal");
          }}
        >
          <AddIcon />
        </Fab>
      </div>
    ) : (
      <div
        style={{
          height: "calc(100vh - 160px)",
          overflow: "scroll"
        }}
      >
        <div
          style={{
            margin: "10px",
            maxHeight: "90vh"
          }}
        >
          {closedDeals.map((data, index) => (
            <div>
              <Card style={{ borderRadius: "10px" }}>
                {this.state.expanded === index ? (
                  ""
                ) : (
                  <CardContent
                    style={{ padding: "0px" }}
                    className={classnames(classes.expand, {
                      [classes.expandOpen]: this.state.expanded
                    })}
                    onClick={() => this.handleExpandClick(index)}
                    aria-expanded={this.state.expanded}
                    aria-label="View All"
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        padding: "10px"
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center"
                        }}
                      >
                        <div
                          style={{
                            width: "220px",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            fontSize: "1em",
                            whiteSpace: "nowrap"
                          }}
                        >
                          <span>{data.sellerName} - </span>
                          <span>{data.buyerName}</span>
                        </div>
                        <span
                          style={{
                            display: "flex",
                            paddingTop: "3px",
                            justifyContent: "space-between",
                            fontSize: "0.8em",
                            color: grey
                          }}
                        >
                          <span
                            style={{
                              maxWidth: "auto",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap"
                            }}
                          >
                            {data.products}
                          </span>
                          <span>{this.getDateValue(data.date)}</span>
                          <span>{data.typeOfRate}</span>
                        </span>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          borderRadius: "15px",
                          justifyContent: "center",
                          alignItems: "center",
                          width: "100px",
                          height: "60px",
                          backgroundColor: primaryShade2
                        }}
                      >
                        <span
                          style={{
                            display: "flex",
                            justifyContent: "space-around"
                          }}
                        >
                          <span>{data.quantity} Ton</span>
                        </span>
                        <Divider
                          style={{
                            marginTop: "1px",
                            borderBottom: "1px black",
                            marginLeft: "5px",
                            height: "2px",
                            width: "80%",
                            marginRight: "5px"
                          }}
                        />
                        <span
                          style={{
                            display: "flex",
                            justifyContent: "space-around"
                          }}
                        >
                          <span>&#8377; {data.rate}</span>
                        </span>
                      </div>
                    </div>
                  </CardContent>
                )}
                <Collapse
                  in={this.state.expanded === index}
                  timeout="auto"
                  onClick={() => this.handleExpandClick(index)}
                  unmountOnExit
                >
                  <CardContent>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center"
                      }}
                    >
                      <div
                        style={{
                          width: "45%",
                          flexDirection: "column"
                        }}
                      >
                        <span
                          style={{
                            display: "flex",
                            justifyContent: "space-around",
                            alignContent: "center"
                          }}
                        >
                          <span
                            style={{
                              color: primaryShade1,
                              fontSize: "10px",
                              paddingTop: "3px",
                              paddingRight: "3px"
                            }}
                          >
                            From
                          </span>
                          <span
                            style={{
                              width: "100%",
                              overflow: "hidden",
                              fontSize: "1em",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap"
                            }}
                          >
                            {data.sellerName}
                          </span>
                        </span>
                        <span
                          style={{
                            display: "flex",
                            justifyContent: "space-around",
                            alignContent: "center"
                          }}
                        >
                          <span
                            style={{
                              color: primaryShade1,
                              fontSize: "10px",
                              paddingLeft: "11px",
                              paddingTop: "3px",
                              paddingRight: "3px"
                            }}
                          >
                            To
                          </span>
                          <span
                            style={{
                              width: "100%",
                              overflow: "hidden",
                              fontSize: "1em",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap"
                            }}
                          >
                            {data.buyerName}
                          </span>
                        </span>
                      </div>
                      <div style={{ width: "65%" }}>
                        <span
                          style={{
                            display: "flex",
                            fontSize: "0.8em",
                            justifyContent: "space-around"
                          }}
                        >
                          <span>{data.quantity} Ton</span>
                          <span>&#8377; {data.rate}</span>
                        </span>
                        <Divider
                          style={{
                            marginTop: "1px",
                            borderBottom: "2px solid orange",
                            marginLeft: "10px",
                            marginRight: "10px"
                          }}
                        />
                        <span
                          style={{
                            display: "flex",
                            fontSize: "0.8em",
                            justifyContent: "space-around",
                            color: grey
                          }}
                        >
                          <span>{this.getDateValue(data.date)}</span>
                          <span
                            style={{
                              textOverflow: "ellipsis",
                              overflow: "hidden"
                            }}
                          >
                            {data.products}
                          </span>
                          <span>{data.typeOfRate}</span>
                        </span>
                      </div>
                    </div>
                  </CardContent>

                  <CardContent style={{ padding: "0px 6px 0px" }}>
                    <div id="cardContent">
                      {transactions.map(tdata =>
                        tdata.dealId === data.id ? (
                          <div
                            style={{
                              display: "flex",
                              marginBottom: "3px",
                              fontSize: "0.8em",
                              borderBottom: "1px solid grey",
                              width: "100%"
                            }}
                          >
                            <span
                              style={{
                                display: "flex",
                                justifyContent: "left",
                                flexDirection: "row",
                                paddingRight: "10px"
                              }}
                            >
                              {this.getDateValue(tdata.date)}
                            </span>
                            <span
                              style={{
                                display: "flex",
                                justifyContent: "left",
                                flexDirection: "row",
                                color: grey,
                                width: "60%"
                              }}
                            >
                              {tdata.paymentMethod
                                ? `Payment/${tdata.paymentMethod}`
                                : `${tdata.transporter}/${tdata.vehicleNumber}`}
                            </span>
                            <span
                              style={{
                                display: "flex",
                                justifyContent: "right",
                                flexDirection: "row"
                              }}
                            >
                              {tdata.quantity ? (
                                `${tdata.quantity} Ton`
                              ) : (
                                <span>&#8377; {tdata.amount}</span>
                              )}
                            </span>
                          </div>
                        ) : null
                      )}
                      <br />
                      <div
                        style={{
                          height: "50px",
                          display: "flex",
                          justifyContent: "flex-end",
                          alignItems: "center",
                          borderBottom: "1px solid lightGrey"
                        }}
                      >
                        <span
                          onClick={e => {
                            e.preventDefault();
                            this.props.history.push(
                              `/deals/singleDealDetails/${data.id}`
                            );
                          }}
                          style={{
                            marginTop: "5px",
                            textDecoration: "underline",
                            color: primaryShade1
                          }}
                        >
                          View All
                        </span>
                      </div>
                    </div>
                  </CardContent>
                </Collapse>
              </Card>
              <br />
            </div>
          ))}
          <Fab
            aria-label="Add"
            style={{
              position: "fixed",
              bottom: "70px",
              right: "20px",
              backgroundColor: primaryShade1
            }}
            onClick={e => {
              e.preventDefault();
              this.props.history.push("/deals/addDeal");
            }}
          >
            <AddIcon />
          </Fab>
        </div>
      </div>
    );
  }
}

export default withRouter(withStyles(styles)(ClosedDeals));
